import { render, staticRenderFns } from "./CsSolicitudesNacionalesDetCarga.vue?vue&type=template&id=35d85545"
import script from "./CsSolicitudesNacionalesDetCarga.vue?vue&type=script&lang=js"
export * from "./CsSolicitudesNacionalesDetCarga.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports